import React from "react";
import { Row, Col, Popover } from "antd";
import Router from "next/router";
import HostConfig from "$ACTIONS/Host.config";
import CMSOBJ from "$DATA/stage.live.static.id";
import Image from "next/image";
import ImageWithFallback from "@/ImageWithFallback/imgLocal";
export default class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Menudata: "",
            HlepMenudata: "",
            showWechatQrcode: false,
        };
    }
    render() {
        const footerIcon = [
            "NETENT",
            "双赢棋牌",
            "playtech",
            "INPLAYMATRIX",
            "BTi",
            "Microgaming",
            // "eBET",
            "KY",
            "Evolution",
            "WINWIN",
            // "CASINO",
            "PG",
            "PRAGMATIC",
            "ZUI",
            "沙巴体育",
            "AG",
            "BETSOFT",
            "Spadegaming",
            "GAMING",
            "SKYWIND",
            "LBKENO",
            "歐博",
            "大遊",
            "TPGAMING",
            "VIR2ALSPORTS",
            "SPRIBE",
            "DGG",
        ];
        return (
            <React.Fragment>
                <div className="common-distance-wrap footer-platform-wrap">
                    <div className="common-distance">
                        <Row className="footer-platform">
                            <Col span={10}>
                                <h4>支付方式</h4>
                                <ul className="icon-list pay-kind">
                                    <li className="icon-item2 _1">
                                        <Popover
                                            content="在线支付宝"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li>
                                    <li className="icon-item2 _2">
                                        <Popover
                                            content="在线支付"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li>
                                    <li className="icon-item2 _3">
                                        <Popover
                                            content="微支付"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li>
                                    <li className="icon-item2 _4">
                                        <Popover
                                            content="京东钱包"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li>

                                    {/* <li className="icon-item2 _5">
                                        <Popover
                                            content="Astropay"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li>

                                    <li className="icon-item2 _6">
                                        <Popover
                                            content="FASTBANK"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li> */}
                                </ul>
                            </Col>
                            <Col span={5}>
                                <h5>关注我们</h5>
                                <ul className="icon-list about-we">
                                    <Popover
                                        content="官方微博"
                                        title=""
                                        trigger="hover"
                                        overlayClassName="footer-popover"
                                    >
                                        <li
                                            className="icon-item2 _7"
                                            onClick={() => {
                                                window.open(
                                                    "https://weibo.com/fun88angel?is_hot=1",
                                                    "_blank"
                                                );
                                                Pushgtagdata(
                                                    "Sina_socialmedia_footer_homepage"
                                                );
                                            }}
                                        ></li>
                                    </Popover>
                                    <Popover
                                        content="优酷官方"
                                        title=""
                                        trigger="hover"
                                        overlayClassName="footer-popover"
                                    >
                                        &nbsp;
                                        <li
                                            className="icon-item2 _8"
                                            onClick={() => {
                                                window.open(
                                                    "https://m.youku.com/profile?callApp=1&showHeader=1&uid=UNDcxOTM4MzAw%E2%80%8B",
                                                    "_blank"
                                                );
                                                Pushgtagdata(
                                                    "Tencent_socialmedia_footer_homepage"
                                                );
                                            }}
                                        ></li>
                                    </Popover>
                                </ul>
                            </Col>
                            <Col span={5}>
                                <h5>博彩责任</h5>
                                <ul className="icon-list regulation">
                                    <Popover
                                        content="GAMCARE"
                                        title=""
                                        trigger="hover"
                                        overlayClassName="footer-popover"
                                    >
                                        &nbsp;
                                        <li
                                            className="icon-item2 _9"
                                            onClick={() => {
                                                window.open(
                                                    "http://www.gamcare.org.uk/",
                                                    "_blank"
                                                );
                                            }}
                                        ></li>
                                    </Popover>

                                    <li className="icon-item2 _10">
                                        <Popover
                                            content="21 岁以上"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_">
                                                <a
                                                    target="_blank"
                                                    onClick={() => {
                                                        Router.push(
                                                            "/Help?type=Sub3&key=" +
                                                                CMSOBJ[
                                                                    HostConfig
                                                                        .CMS_ID
                                                                ][25]
                                                        );
                                                    }}
                                                >
                                                    &nbsp;
                                                </a>
                                            </div>
                                        </Popover>
                                    </li>
                                </ul>
                            </Col>
                            <Col span={4}>
                                <h5>信息安全</h5>
                                <ul className="icon-list regulation">
                                    <li className="icon-item2 _11">
                                        <Popover
                                            content="IOVATION"
                                            title=""
                                            trigger="hover"
                                            overlayClassName="footer-popover"
                                        >
                                            <div className="_set_"></div>
                                        </Popover>
                                    </li>
                                </ul>
                            </Col>
                            {/* <Col span={4}>
								<h5>运营监管</h5>
								<ul className="icon-list regulation">
									<Popover content="IOVATION" title="" trigger="hover" overlayClassName="footer-popover"><a target="_blank" href="http://www.dalujiedu.com/">&nbsp;<li className="icon-item2 _12"></li></a></Popover>
								</ul>
							</Col> */}
                            {/* <Col span={4}>
								<h5>语言</h5>
								<Select size="small" dropdownClassName="footer-small-drop" suffixIcon={<CaretDownFilled />} defaultValue="china">
									<Select.Option value="china" className="tlc-sprite _china">中文</Select.Option>
								</Select>
							</Col> */}
                        </Row>
                        <div>
                            <h4>游戏平台</h4>
                            <Row gutter={16}>
                                {footerIcon.map((item, index) => {
                                    return (
                                        <Col
                                            span={3}
                                            style={{
                                                width: "140px",
                                                height: "36px",
                                                marginTop: "10px",
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                            key={index}
                                            onMouseEnter={() => {
                                                this.setState({
                                                    ["showHoverFooterIcon" +
                                                    index]: false,
                                                });
                                            }}
                                            onMouseLeave={() => {
                                                this.setState({
                                                    ["showHoverFooterIcon" +
                                                    index]: true,
                                                });
                                            }}
                                        >
                                            <ImageWithFallback
                                                src={
                                                    this.state[
                                                        "showHoverFooterIcon" +
                                                            index
                                                    ] == false || undefined
                                                        ? `/cn/img/footer/hoverIcon/hover-${item}.png`
                                                        : `/cn/img/footer/${item}.png`
                                                }
                                                width={140}
                                                height={36}
                                                alt={item}
                                            />
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="common-distance-wrap footer-copyright-wrap">
                    <div className="common-distance clear-padding">
                        <Row>
                            <Col span={3} className="copyright-picture">
                                <ImageWithFallback
                                    src={`/cn/img/home/part/img.png`}
                                    width={122}
                                    height={118}
                                    alt={"card"}
                                />
                            </Col>
                            <Col span={21} className="copyright-article">
                                <p>
                                    www.fun88.com is operated by E Gambling
                                    Montenegro d.o.o. (81000 Podgorica,
                                    Moskovska br. 65., reg. no.5-0615951) in
                                    cooperation with OG GLOBAL ACCESS LIMITED
                                    (P.O. Box 3340, Road Town, Tortola, British
                                    Virgin Islands.
                                </p>
                                <p>
                                    E Gambling Montenegro d.o.o. (81000
                                    Podgorica, Moskovska br. 65., reg.
                                    no.5-0615951) hereby certifies that under
                                    the concession (serial no. AA 001588,
                                    numeric no. 133-01/15 4A and 1ER) and
                                    approval (no. 02/01-118/4), organize and
                                    operate games of chance in Montenegro on
                                    website www.fun88.com , in accordance with
                                    the Agreement, concluded between E Gambling
                                    Montenegro d.o.o. and OG GLOBAL ACCESS
                                    LIMITED (P.O. Box 3340, Road Town, Tortola,
                                    British Virgin Islands, reg. no. 1923130) on
                                    07 October 2021
                                </p>
                            </Col>
                        </Row>
                        <div className="copyright-content">
                            <p>本站属于OG GLOBAL ACCESS LIMITED 运营</p>
                            <p>
                                于2021年10月07日起由E Gambling Montenegro d.o.c 授权及监管。
                            </p>
                            <p>© 版权所有 违者必究</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
